import React, { useState } from 'react'
import { Collapse, Card,Row,Col } from 'react-bootstrap'
import classnames from 'classnames'
//import { ChevronDown } from 'react-feather'
import FeatherIcon from 'feather-icons-react'
import PerfectScrollbar from 'react-perfect-scrollbar'

const AccordionChildren = (props) => {
  const { collapseItems, defaultOpenId = 1 } = props
  const [isElement, setIsElement] = useState(true)
  const [state, setState] = useState({
    collapseID: defaultOpenId,
    status: 'Opened',
  })

  const toggleCollapse = (id) => {
    let collapseId = props.collapseID !== id ? id : ''
    setState({
      ...state,
      collapseID: collapseId,
    })
    props.onOpenIdChange(collapseId)
  }
  const onEntered = (id) => {
    if (id === props.collapseID) setState({ ...state, status: 'Opened' })
  }
  const onEntering = (id) => {
    if (id === props.collapseID) setState({ ...state, status: 'Opening...' })
  }

  const onExited = (id) => {
    if (id === props.collapseID) setState({ ...state, status: 'Closed' })
  }

  const onExiting = (id) => {
    if (id === props.collapseID) setState({ ...state, status: 'Closing...' })
  }

  const accordionItem = (collapseItem) => {
    return (
      <Card
        key={collapseItem.id}
        className="border-primary" 
      >
        <Card.Header
          onClick={() => toggleCollapse(collapseItem.id)}
          style={{ cursor: 'pointer' }}
          className={`bg-primary p-10`}
        >
          <Row className="d-flex align-items-center">
            <Col sm="" className="pr-0">
              <div className="lead collapse-title collapsed">{collapseItem.title}</div>
            </Col>
            <Col sm="auto">
              {(collapseItem.alwaysOpen || collapseItem.id === props.collapseID) ? (
                <FeatherIcon size="18" icon="chevron-down" />
              ) : (
                <FeatherIcon size="18" icon="chevron-up" />
              )}
            </Col>
          </Row>
        </Card.Header>
        <Collapse
          in={
            collapseItem.alwaysOpen || collapseItem.id === props.collapseID
          }
          onEntering={() => onEntering(collapseItem.id)}
          onEntered={() => onEntered(collapseItem.id)}
          onExiting={() => onExiting(collapseItem.id)}
          onExited={() => onExited(collapseItem.id)}
        >
          <Card.Body className="p-0 border-secondary rounded-bottom">
            <PerfectScrollbar
              className="p-2"
              style={{ maxHeight: props.maxHeight }}
              options={{
                wheelPropagation: false,
              }}
            >
              {collapseItem.content}
            </PerfectScrollbar>
          </Card.Body>
        </Collapse>
      </Card>
    )
  }

  const accordionItem2 = (collapseItem) => {
    return (<div>
      <Card
        key={collapseItem.id}
        className={classnames(
          {
            'collapse-collapsed':
              state.status === 'Closed' && props.collapseID === collapseItem.id,
            'collapse-shown':
              state.status === 'Opened' && props.collapseID === collapseItem.id,
            closing:
              state.status === 'Closing...' &&
              props.collapseID === collapseItem.id,
            opening:
              state.status === 'Opening...' &&
              props.collapseID === collapseItem.id,
          },
          'border-secondary',
          'my-1'
        )}
      >
        <Card.Header
          onClick={() => toggleCollapse(collapseItem.id)}
          className={classnames(
            {
              'collapse-collapsed':
                state.status === 'Closed' &&
                props.collapseID === collapseItem.id,
              'collapse-shown':
                state.status === 'Opened' &&
                props.collapseID === collapseItem.id,
              closing:
                state.status === 'Closing...' &&
                props.collapseID === collapseItem.id,
              opening:
                state.status === 'Opening...' &&
                props.collapseID === collapseItem.id,
              'bg-secondary': props.collapseID === collapseItem.id,
            },
            'border-secondary',
            'p-1'
          )}
          style={{ cursor: 'pointer' }}
        >
          <Card.Title className="lead collapse-title collapsed">
            {collapseItem.title}
          </Card.Title>          
          <FeatherIcon
                      size="15"
                      icon="chevron-down"
                      className="vx-icon collapse-icon"            
                    />

        </Card.Header>            
      </Card>
      {collapseItem.content}
    </div>      
    )
  }

  //<div>child.props.title</div>
  let index = 0
  return (
    <div className="vx-collapse">
      {React.Children.map(props.children, (child) =>
        accordionItem({
          id: ++index,
          title: child.props.title,
          content: child,
          alwaysOpen: child.props.alwaysOpen,
        })
      )}
    </div>
  )
}

export default AccordionChildren;
